<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Request Details",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Request Details",
            items: [
               {
                  text: "Requests",
                  href: "/requests",
               },                
               
               {
                  text: "Details",
                  active: true,
               },                     
            ],

            order: {
               location: 'Kochi, Kerala, India',
            },
            
            marker: { position: { lat: 9.9312328, lng: 76.26730409999999 } },
            center: { lat: 9.9312328, lng: 76.26730409999999 },

            mapOptions: {
               disableDefaultUI: true,
            },              
            token: '',
            errors: {}

         };
      },
      mounted() {
    
      },
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
                        
                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  <!---- listing table starts -------->
                  <div class="row">
                     <div class=" col-md-6 col-lg-6">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           
                           <div class="table-responsive">
                              <table class="table mb-0">
                                 
                                 <tbody>                                   
                                    
                                    <tr>
                                       <th>Name</th>
                                       <th>:</th>
                                       <td>Peter John</td>
                                    </tr>                         
                                    
                                    <tr>
                                       <th>Mobile</th>
                                       <th>:</th>
                                       <td>+91 9110011001</td>
                                    </tr> 

                                    <tr>
                                       <th>Delivery Type</th>
                                       <th>:</th>
                                       <td>Regular</td>
                                    </tr>

                                    <tr>
                                       <th>Delivery Date</th>
                                       <th>:</th>
                                       <td>10 Mar 2022 12:00 pm</td>
                                    </tr>       

                                    <tr>
                                       <th>Delivery Address</th>
                                       <th>:</th>
                                       <td>Edappalli, Kochi</td>
                                    </tr>

                                    <tr>
                                       <th>Private Delivery</th>
                                       <th>:</th>
                                       <td>No</td>
                                    </tr>

                                    <tr>
                                       <th>Created On</th>
                                       <th>:</th>
                                       <td>20 Oct 2021, 6:30pm</td>
                                    </tr>

                                    <tr>
                                       <th>Remarks</th>
                                       <th>:</th>
                                       <td>Sed efficitur lorem nec neque eleifend, quis rutrum ligula luctus. Praesent dapibus dolor nunc, ut dictum ante lacinia sit amet. Aliquam sed tellus justo.</td>
                                    </tr>
                                 </tbody>
                              </table>
                           </div>
                        </b-card>
                     </div>
                     <div class=" col-md-6 col-lg-6">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 p-3 mb-3">Medicine Details</h4>
                           <p>Donec dapibus orci turpis. Praesent vitae lacus ligula. Pellentesque nulla nisl, ultrices ac augue vitae, ultrices bibendum mauris. Sed efficitur lorem nec neque eleifend, quis rutrum ligula luctus. Praesent dapibus dolor nunc, ut dictum ante lacinia sit amet. Aliquam sed tellus justo. </p>

                           <h5 class="mt-5">Prescription</h5>
                           <ul class="list-inline p-0 m-0">                     
                              <li class="mb-3">
                                 <a href="#"><p class="text-primary"><i class="fas fa-file-alt me-3"></i> Prescription</p></a>  
                              </li>
                              
                           </ul>
                        </b-card>


                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 bg-light border border-top-0 border-start-0 border-end-0 p-3 mb-3">Location</h4>
                           <b-row>                          

                              <b-col md="12" lg="12">
                                 <p>{{order.location}}</p>                              
                              </b-col> 
                              <b-col  md="12">
                                 <GmapMap v-if="order.location"
                                 :center="center"
                                 :zoom="18"
                                 map-style-id="roadmap"
                                 :options="mapOptions"
                                 style="width: 100%; height: 300px"
                                 ref="mapRef">                              
                                    <GmapMarker
                                       :position="marker.position"
                                       :clickable="false"
                                       :draggable="false"                                    
                                    />
                              </GmapMap>        
                              </b-col>

                           </b-row>
                        </b-card>
                     </div>
                  </div>
                  <!---- listing table ends -------->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
